import React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

function getPosition(startOfDay, endOfDay) {
  const now = moment();

  const hours = now.hour() - startOfDay;

  const nowMinutes = (hours * 60) + now.minute();
  const totalMinutes = ((endOfDay - startOfDay) * 60) + 60;

  return (nowMinutes * 100) / totalMinutes;
}

function WeeklyHourIndicator({ startOfDay = 8, endOfDay = 18 }) {
  const position = getPosition(startOfDay, endOfDay);

  if (position < 0 || position > 100) {
    return null;
  }

  const indicatorStyle = {
    top: `calc(${position}%)`,
  };

  return (
    <div className="c-calendar__indicator" style={indicatorStyle} />
  );
}

WeeklyHourIndicator.propTypes = {
  endOfDay: PropTypes.number,

  startOfDay: PropTypes.number,
};

export default WeeklyHourIndicator;
